{
  "nav": {
    "home": "Home",
    "calendar": "Calendar",
    "analytics": "Analytics",
    "settings": "Settings",
    "users": "Users",
    "help": "Help",
    "needsDriver": "Needs Driver",
    "appointments": "Appointments",
    "sentryTest": "🐛 Test Error"
  },
  "appointments": {
    "title": "Appointments",
    "create": "Create Appointment",
    "createTitle": "Create New Appointment",
    "createDescription": "Add a new appointment to your calendar",
    "editTitle": "Edit Appointment",
    "edit": "Edit",
    "delete": "Delete",
    "deleteTitle": "Delete Appointment?",
    "deleteConfirmation": "Are you sure you want to delete this appointment? This action cannot be undone.",
    "deleting": "Deleting...",
    "myAppointments": "Mine",
    "othersAppointments": "Others'",
    "pastAppointments": "Past",
    "noOthersAppointments": "No other appointments",
    "noOthersAppointmentsDescription": "No upcoming appointments assigned to other family members.",
    "noPastAppointments": "No past appointments",
    "noPastAppointmentsDescription": "No appointments have been completed yet.",
    "editDescription": "Update appointment details",
    "assign": "Assign Driver",
    "unassign": "Unassign",
    "claim": "Claim",
    "duration": "Duration",
    "location": "Location",
    "locationPlaceholder": "Enter location",
    "date": "Date",
    "time": "Time",
    "selectDate": "Select a date",
    "selectTime": "Select time",
    "selectDuration": "Select duration",
    "status": "Status",
    "assigned": "Assigned",
    "unassigned": "Unassigned",
    "completed": "Completed",
    "description": "Description",
    "descriptionPlaceholder": "Add any additional notes or details",
    "descriptionOptional": "Optional - any additional notes about the appointment",
    "titlePlaceholder": "Enter appointment title",
    "noAppointments": "No appointments found",
    "noUnassigned": "No unassigned appointments",
    "errorLoading": "Failed to load appointments. Please try again.",
    "createdBy": "Created by",
    "claiming": "Claiming...",
    "unclaiming": "Unclaiming...",
    "timeFormat": "HH:MM format",
    "noAppointmentsScheduledForDate": "No appointments scheduled for this date",
    "allAppointmentsAssigned": "All appointments are assigned",
    "noUnassignedDescription": "All upcoming appointments have drivers assigned. Great job, family!",
    "yourAppointment": "Your appointment",
    "appointmentNeedDrivers": "Appointments that need drivers",
    "noAssignedAppointmentsDescription": "You don't have any assigned appointments yet. Check for appointments that need drivers or create a new one.",
    "needingDrivers": "appointments needing drivers",
    "needsDriver": "Needs Driver",
    "claimThisAppointment": "Claim this appointment",
    "noUpcomingAppointments": "No upcoming appointments",
    "assignTo": "Assign to",
    "selectAssignee": "Select a person",
    "assignToDescription": "Optional - assign this appointment to someone"
  },
  "forms": {
    "cancel": "Cancel",
    "create": "Create",
    "creating": "Creating...",
    "edit": "Edit",
    "update": "Update",
    "updating": "Updating...",
    "delete": "Delete",
    "title": "Title",
    "description": "Description",
    "titleRequired": "Title is required",
    "titleTooLong": "Title too long",
    "locationRequired": "Location is required",
    "locationTooLong": "Location too long",
    "startTimeRequired": "Start time is required",
    "durationMin": "Duration must be at least 15 minutes",
    "durationMax": "Duration cannot exceed 8 hours",
    "descriptionTooLong": "Description too long"
  },
  "users": {
    "title": "Users",
    "createUser": "Add User",
    "createUserTitle": "Add New User",
    "createUserDescription": "Add a family member before they sign in",
    "name": "Name",
    "namePlaceholder": "Enter full name",
    "email": "Email",
    "emailPlaceholder": "Enter email address",
    "pending": "Pending",
    "active": "Active",
    "deleteUser": "Delete User",
    "deleteUserConfirmation": "Are you sure you want to delete this user? They will be unassigned from any appointments.",
    "noUsers": "No users yet",
    "noUsersDescription": "Add family members so they can be assigned to appointments before they sign in.",
    "userCreated": "User added",
    "userCreatedDescription": "The user has been added and can now be assigned to appointments.",
    "userDeleted": "User deleted",
    "userDeletedDescription": "The user has been removed.",
    "createError": "Failed to create user",
    "deleteError": "Failed to delete user"
  },
  "analytics": {
    "title": "Analytics",
    "driverStats": "Driver Statistics",
    "weeklyOverview": "Weekly Overview",
    "appointmentsThisWeek": "Appointments This Week",
    "totalAppointments": "Total Appointments",
    "assignmentRate": "Assignment Rate",
    "upcomingUnassigned": "Upcoming Unassigned",
    "driverStatsDescription": "Number of appointments per family member",
    "weeklyOverviewDescription": "Appointments per week over the last month",
    "noDriverData": "No driver data available",
    "noWeeklyData": "No weekly data available",
    "weekLabel": "Week {{number}}"
  },
  "time": {
    "hour": "hour",
    "hours": "hours",
    "minute": "minute",
    "minutes": "minutes"
  },
  "common": {
    "loading": "Loading...",
    "error": "An error occurred",
    "close": "Close",
    "you": "You",
    "thisWeek": "This week",
    "needDrivers": "Need drivers",
    "last30Days": "Last 30 days",
    "allTime": "All time",
    "unknown": "Unknown",
    "driver": "Driver"
  },
  "calendar": {
    "title": "Calendar",
    "calendarView": "Calendar View",
    "appointmentsFor": "Appointments for",
    "selectedDate": "Selected Date",
    "noAppointments": "No appointments"
  },
  "auth": {
    "signIn": "Sign In",
    "signOut": "Sign Out",
    "signInWithGoogle": "Sign in with Google",
    "signInDescription": "Sign in to access your family appointment management",
    "authorizedUsersOnly": "Only authorized family members can access this application"
  },
  "settings": {
    "title": "Settings",
    "calendarSubscription": "Calendar Subscription",
    "calendarSubscriptionDescription": "Get a personal calendar URL that you can add to Google Calendar, Outlook, or any other calendar application",
    "calendarUrl": "Calendar URL",
    "calendarUrlHelp": "Copy this URL and add it to your calendar application as a new subscription",
    "regenerateUrl": "Regenerate URL",
    "regenerateUrlDescription": "Generate a new calendar URL if the current one has been compromised",
    "regenerate": "Regenerate",
    "calendarPreferences": "Calendar Preferences",
    "calendarPreferencesDescription": "Customize how your appointments appear in your calendar",
    "appointmentScope": "Appointment Visibility",
    "ownAppointments": "Only my appointments",
    "allAppointments": "All family appointments",
    "showAsBusy": "Show as busy",
    "showAsBusyDescription": "Mark appointment times as busy in your calendar",
    "instructions": "Setup Instructions",
    "instructionsDescription": "How to add this calendar to your preferred calendar application",
    "googleCalendar": "Google Calendar",
    "googleStep1": "Open Google Calendar in your web browser",
    "googleStep2": "Click the '+' button next to 'Other calendars'",
    "googleStep3": "Select 'From URL' and paste the calendar URL above",
    "googleStep4": "Click 'Add calendar' to subscribe",
    "outlookCalendar": "Microsoft Outlook",
    "outlookStep1": "Open Outlook and go to Calendar",
    "outlookStep2": "Right-click 'Other calendars' and select 'Add calendar'",
    "outlookStep3": "Choose 'Subscribe from web' and paste the URL",
    "outlookStep4": "Click 'Import' to add the calendar",
    "urlCopied": "URL copied!",
    "urlCopiedDescription": "Calendar URL has been copied to your clipboard",
    "copyError": "Failed to copy URL to clipboard",
    "tokenRegenerated": "URL regenerated!",
    "tokenRegeneratedDescription": "A new calendar URL has been generated",
    "regenerateError": "Failed to regenerate calendar URL"
  },
  "help": {
    "title": "Help & Guide",
    "gettingStarted": {
      "title": "Getting Started",
      "description": "Learn the basics of using Termine for family appointment management",
      "login": {
        "title": "How to Sign In",
        "description": "Only authorized family members can access Termine. Here's how to get started:",
        "step1": "Click the 'Sign In' button on the login page",
        "step2": "Choose 'Sign in with Google' and use your Google account",
        "step3": "If your email is authorized, you'll be redirected to the main dashboard"
      },
      "firstSteps": {
        "title": "Your First Steps",
        "step1": "Check your language preference (switch between English/German using the language button)",
        "step2": "Visit Settings to set up your personal calendar subscription",
        "step3": "Create your first appointment or check if others have already been created"
      }
    },
    "appointments": {
      "title": "Managing Appointments",
      "description": "Learn how to create, edit, and manage family appointments",
      "create": {
        "title": "Creating an Appointment",
        "step1": "Click 'Create Appointment' from the main page or appointments page",
        "step2": "Fill in the appointment details: title, date, time, duration, and location",
        "step3": "Add a description if needed (optional but helpful for family members)",
        "step4": "Click 'Create' to save the appointment"
      },
      "claim": {
        "title": "Claiming Appointments as Driver",
        "description": "Family members can volunteer to be the driver for appointments:",
        "step1": "Look for appointments marked as 'Unassigned' - these need a driver",
        "step2": "Click 'Claim' on any appointment you can drive for",
        "step3": "Once claimed, the appointment will show your name as the driver"
      },
      "statuses": {
        "title": "Understanding Appointment Status",
        "unclaimed": "Unassigned",
        "unclaimedDesc": "Needs a driver",
        "claimed": "Assigned",
        "claimedDesc": "Has a driver",
        "completed": "Completed",
        "completedDesc": "Appointment finished",
        "cancelled": "Cancelled",
        "cancelledDesc": "No longer happening"
      }
    },
    "calendar": {
      "title": "Calendar Integration",
      "description": "Connect Termine with your personal calendar apps like Google Calendar or Outlook",
      "setup": {
        "title": "Setting Up Calendar Subscription",
        "step1": "Go to Settings and find the 'Calendar Subscription' section",
        "step2": "Copy your personal calendar URL (it's unique to you)",
        "step3": "Open your preferred calendar app (Google Calendar, Outlook, Apple Calendar, etc.)",
        "step4": "Add the URL as a new calendar subscription following your app's instructions"
      },
      "apps": {
        "title": "Supported Calendar Apps",
        "google": "Google Calendar - Add from URL in 'Other calendars' section",
        "outlook": "Microsoft Outlook - Subscribe from web in calendar settings",
        "apple": "Apple Calendar - Add subscription calendar in Calendar app",
        "other": "Any app that supports ICS/iCal subscription URLs"
      }
    },
    "settings": {
      "title": "Settings & Preferences",
      "description": "Customize how Termine works for you",
      "language": {
        "title": "Language",
        "description": "Switch between English and German using the language button in the top navigation"
      },
      "calendar": {
        "title": "Calendar Preferences",
        "description": "Control what appointments appear in your personal calendar:",
        "scope": "Appointment Visibility - Choose to see only your appointments or all family appointments",
        "busy": "Show as Busy - Mark appointment times as busy periods in your calendar"
      }
    },
    "analytics": {
      "title": "Analytics & Reports",
      "description": "View family appointment statistics and activity",
      "charts": {
        "title": "Understanding the Charts",
        "appointments": "Total appointments created and completed over time",
        "completion": "How many appointments each family member has completed",
        "activity": "Recent activity showing who created, claimed, or updated appointments"
      }
    },
    "mobile": {
      "title": "Using on Mobile Devices",
      "description": "Termine works great on phones and tablets",
      "access": {
        "title": "Accessing on Mobile",
        "step1": "Open your mobile web browser (Safari, Chrome, etc.)",
        "step2": "Navigate to the Termine website URL",
        "step3": "Add it to your home screen for easy access (optional)"
      },
      "tips": {
        "title": "Mobile Tips",
        "tip1": "The interface automatically adapts to your screen size",
        "tip2": "All features work the same way as on desktop computers",
        "tip3": "You can claim appointments quickly while on the go"
      }
    },
    "troubleshooting": {
      "title": "Troubleshooting",
      "description": "Solutions to common problems",
      "common": {
        "title": "Common Issues",
        "login": "I can't sign in",
        "loginSolution": "Make sure your email address is authorized by a family administrator. Contact them if you're having trouble.",
        "calendar": "My calendar isn't updating",
        "calendarSolution": "Try regenerating your calendar URL in Settings, then re-add it to your calendar app.",
        "mobile": "The app doesn't work on my phone",
        "mobileSolution": "Make sure you're using a modern web browser. Try clearing your browser cache or using a different browser."
      }
    },
    "contact": {
      "title": "Need More Help?",
      "description": "If you're still having trouble, contact your family administrator",
      "content": "This app is managed by your family. If you need help with access, have questions, or encounter problems, reach out to the person who set up Termine for your family."
    }
  },
  "sentryTest": {
    "title": "Sentry Error Testing",
    "warning": "This page is for testing error monitoring. Only use in development.",
    "syncErrorTitle": "Synchronous Error",
    "syncErrorDescription": "Throws an error immediately in the component",
    "asyncErrorTitle": "Async Error",
    "asyncErrorDescription": "Throws an error after a short delay",
    "manualCaptureTitle": "Manual Capture",
    "manualCaptureDescription": "Manually captures an exception to Sentry",
    "triggerError": "Trigger Error",
    "instructions": "How to Test",
    "step1": "Click one of the buttons above to trigger an error",
    "step2": "Check your browser console and network tab for the error",
    "step3": "Verify the error appears in your Sentry dashboard at sentry.io"
  }
}
